import { PlayerAhoyEvent } from './player_ahoy_event';
import { PlayerEnvironment } from './player_environment';


export class PlayerError {
  constructor(options = {}) {
    this._data = options.data;
    this._tech = options.tech;
    this._blocker = options.blocker;
    this.setAhoyEventGlobalProperties();
  }

  get data() {
    return this._data;
  }
  get tech() {
    return this._tech;
  }
  get blocker() {
    return this._blocker;
  }

  showError(errorCode) {
    if (this.blocker.isShown) return;

    this.tech.pause();
    this.tech.el().addClass('vjs-error');

    if (errorCode == 1) {
      PlayerAhoyEvent.sendBlocker(
        this.data.type().toLowerCase(),
        this.data.isPremier(),
        this.data.videoId(),
        'general_error'
      );
      this.blocker.renderBlocker('fetching_error');

      return;
    }

    if (errorCode == 2) {
      PlayerAhoyEvent.sendBlocker(
        this.data.type().toLowerCase(),
        this.data.isPremier(),
        this.data.videoId(),
        'network_error'
      );
      this.blocker.renderBlocker('network_error');

      return;
    }

    if (errorCode == 3) {
      PlayerAhoyEvent.sendBlocker(
        this.data.type().toLowerCase(),
        this.data.isPremier(),
        this.data.videoId(),
        'media_error'
      );
      this.blocker.renderBlocker('media_error');

      return;
    }

    if (errorCode == 4) {
      PlayerAhoyEvent.sendBlocker(
        this.data.type().toLowerCase(),
        this.data.isPremier(),
        this.data.videoId(),
        'device_error'
      );
      this.blocker.renderBlocker('media_not_supported');

      return;
    }

    if (errorCode == 5) {
      PlayerAhoyEvent.sendBlocker(
        this.data.type().toLowerCase(),
        this.data.isPremier(),
        this.data.videoId(),
        'drm'
      );
      this.blocker.renderBlocker('drm');

      return;
    }

    // error code 6 is used by VideoEvent#triggerMissingM3U8 and existing implementation is to send it as general_error

    if (errorCode == 7) {
      PlayerAhoyEvent.sendBlocker(
        this.data.type().toLowerCase(),
        this.data.isPremier(),
        this.data.videoId(),
        'hdcp'
      );
      this.blocker.renderBlocker('hdcp');

      return;
    }

    PlayerAhoyEvent.sendBlocker(
      this.data.type().toLowerCase(),
      this.data.isPremier(),
      this.data.videoId(),
      'general_error'
    );
    this.blocker.renderBlocker('general_error');

  }

  setAhoyEventGlobalProperties() {
    let globalData = {
      page: PlayerEnvironment.locationHref(),
      videopremier: this.data.isPremier(),
      referrer: PlayerEnvironment.referrer(),
      is_preview: this.data.preview(),
      cdn: this.data.cdnName(),
      embed: this.data.embed() === 'true',
    };
    
    if (this.data.userIsPremier()) {
      globalData.user_type = 'premier';
    }

    if (this.data.isVideo()) {
      if (this.data.filmId() != 0) {
        globalData.film_id = this.data.filmId();
      }

      if (this.data.seasonId() != 0) {
        globalData.season_id = this.data.seasonId();
      }
    }
    PlayerAhoyEvent._globalAppendData = globalData;
  }
}
